import React, { useEffect, useState,useMemo,useContext } from "react";
import Navigation from "../../../components/navbar/Navigation";
import { getErrorCodeList } from "../../../service/MasterService";
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import Table from "../../../components/Table/Table";
import ColumnsErrorCode from "./ColumnsErrorCode";
import { t } from "i18next";
import PageHeader from "../../../components/PageHeader";
import TabContainer from "../../../components/TabContainer/TabContainer";
import ErrorCodeTab from "./ErrorCodeTab";
import ErrorCodeValueTab from "./ErrorCodeValueTab";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb";
import CustomSpinner from "../../../components/CustomSpinner";
import loaderContext from "../../../context/loader/LoaderContext";


const ErrorCodeList = () => {

    const [itemLength, setItemLength] = useState([]);
    const [loading,setLoading] = useState(true);
    const [loadingState, setLoadingState] = useState("");
    const [error, setError] = useState("");
    const [tabDetails, setTabDetails] = useState([]);
    const {ref, setLoaderRunning} = useContext(loaderContext);

    const fetchErrorCodeList = async () => {
      setLoaderRunning(true);
      ref.current.continuousStart();
        const response = await getErrorCodeList();
        console.log(response);
        if (response.status === 200 && response.data.result === "SUCCESS") {
            console.log(response.data.data.errorList);
            setLoading(false);
            let data = response.data.data.errorList;
            setItemLength(data.length);
            let tempList = [];
            data.map((item, index) =>{
              tempList.push({
                selectedKey: index+1,
                tabKeyContain: <ErrorCodeTab key={index+1} orderNumber={index+1} tabName={item.errorCode}  errorDesc={item.errorDescription}/>,
                tabValueContain: <ErrorCodeValueTab key={index+1} action={item.action} reasonOfError={item.reasonOfError} correctiveAction={item.correctiveAction}/>
              })
            });
            setTabDetails(tempList);
        }else{
          setLoading(false);
          setError(response);
        }
        setLoaderRunning(false);
        ref.current.complete();
    };


    useEffect(()=>{
      fetchErrorCodeList();
    },[]);

    const breadCrumbItems = [
      {
        text: t("error-code-list.list"),
        key: "errorlist",
      },
    ];


    return (
      <div className="main-container-body">
      {tabDetails.length > 0 &&
        <TabContainer NoOfTabs={tabDetails.length} tabDetails={tabDetails} uniqueKey="errorcode_" previousNextButtons={false} onNextClick={() => console.log("Next clicked")}
                onEditClick={() => console.log("Next clicked")} breadCrumbItems = {breadCrumbItems}/>
      }
      { {error}&&<p>{error}</p>}
    </div>
    );
  
}

export default ErrorCodeList;